<script>
  import { ClipboardDocumentList } from "svelte-hero-icons";
  import Collapsible from "./Collapsible.svelte";
  import MetricsRecord from "./MetricsRecord.svelte";
  import { tooltip } from "$lib/utils/tooltip";

  export let metrics;
</script>

{#each $metrics as metric}
  <Collapsible icon={ClipboardDocumentList} isOpen={false} variant="inline">
    <div
      slot="title"
      class="grid grid-cols-[1fr_auto] gap-4 w-full text-xs pr-2"
      use:tooltip={{ placement: "top" }}
      aria-label={metric.name}
    >
      <code class="truncate">{metric.name}</code>
      <code class="text-right">{metric.value}</code>
    </div>
    <MetricsRecord {metric} />
  </Collapsible>
{/each}
